import {WsSigningPackageSortField} from '@lifeislife/lifeislife-ws-api';

export type SigningPackageSortField = WsSigningPackageSortField;
export const SigningPackageSortField = {
  ...WsSigningPackageSortField,
};
